import React from "react";
import styled from "styled-components";
import { media } from "utils/style";

const Header = props => <H1 {...props}>{props.children}</H1>;

export default Header;

const H1 = styled.h1`
  font-size: 32px;
  line-height: 30px;
  margin-bottom: 24px;

  ${media.mobile`
    font-size: 25px;	
    line-height: 24px;
  `}
`;
